/*
 * Copyright (C) 2018 - 2023. Entgra (Pvt) Ltd, https://entgra.io
 * All Rights Reserved.
 *
 * Unauthorized copying/redistribution of this file, via any medium
 * is strictly prohibited.
 * Proprietary and confidential.
 *
 * Licensed under the Entgra Commercial License,
 * Version 1.0 (the "License");
 * you may not use this file except in compliance with the License.
 *
 * Unless required by applicable law or agreed to in writing,
 * software distributed under the License is distributed on an
 * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
 * KIND, either express or implied.  See the License for the
 * specific language governing permissions and limitations
 * under the License.
 *
 * You may obtain a copy of the License at
 * https://entgra.io/licenses/entgra-commercial/1.0
 */

import React from 'react';
import { Typography, Descriptions } from 'antd';
import { useTranslation } from 'react-i18next';
const { Paragraph, Text } = Typography;
const { Item } = Descriptions;

const Content = props => {
  const { t } = useTranslation();

  const createPrerequisites = () => {
    const prerequisites = props.prerequisites;
    const prerequisiteList = prerequisites.map((prerequisite, index) => (
      <li key={index}>{prerequisite}</li>
    ));
    return (
      <blockquote>
        <h3 style={{ fontSize: '14px', fontWeight: '500' }}>
          {t('label_prerequisites')}
        </h3>
        <ul>{prerequisiteList}</ul>
      </blockquote>
    );
  };

  // stepInfos [ {title, description(optional), copyables(optional): [{key, value}]}]
  const createStepsInfos = () => {
    const stepInfos = props.stepInfos;
    const stepInfosList = stepInfos.map((stepInfo, index) => {
      return (
        <Descriptions key={index} column={1}>
          {stepInfo.title && (
            <h3 style={{ fontSize: '14px', fontWeight: '500' }}>
              {`${index + 1}) ${stepInfo.title}`}
            </h3>
          )}
          <Paragraph>{stepInfo.description && stepInfo.description}</Paragraph>
          {stepInfo.copyables &&
            stepInfo.copyables.map((copyable, index) => {
              return (
                <Item label={copyable.key} key={index}>
                  <Text copyable={copyable.value} code={true}>
                    {copyable.value}
                  </Text>
                </Item>
              );
            })}
        </Descriptions>
      );
    });
    return stepInfosList;
  };

  const { title, prerequisites, description, stepInfos } = props;

  return (
    <Typography>
      <h3 style={{ fontSize: '14px', fontWeight: '500' }}>{title}</h3>
      {description && <Paragraph>{description}</Paragraph>}
      {prerequisites && createPrerequisites()}
      {stepInfos && createStepsInfos()}
    </Typography>
  );
};

export default Content;
